import React, { useContext, useEffect, useState } from "react";
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
import { addingRegisterDetails } from "../services/authService";
import { useNavigate } from "react-router-dom";
import constants from "../config/constants";
import Toast from 'react-bootstrap/Toast';
import { Spinner } from "react-bootstrap";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import Layout from '../layouts/Layout';


const Register: React.FC = () => {
  const [formData, setFormData] = useState<any>({
    name: "",
    email: "",
    phone: "+91",
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false,

  })
  const [error, setError] = useState({
    name: "",
    email: "",
    password: '',
    confirmPassword: '',
    phone: ''
  });
  const [show, setShow] = useState(false);
  const [successValue, setSuccessValue] = useState("");
  const [message, setMessage] = useState("")


  const toast: any = useContext(AlertContext);
  const currentUser = useContext(RoleContext);
  const navigate = useNavigate();

  const handleSubmit = (event: any) => {
    event.preventDefault()
    let hasError = false

    for (let key in formData) {
      if (formData[key] === '') {
        setError(prevState => ({ ...prevState, [key]: 'Required*' }))
        hasError = true
        return false //or break
      }
    }
    if (formData.password.length < 8) {
      setError(prevState => ({ ...prevState, password: 'Enter the valid password' }))

      hasError = true
      return false
    }
    else if (formData.password !== formData.confirmPassword) {
      setError(prevState => ({ ...prevState, password: 'Password and confirm password should match' }))

      hasError = true
      return false
    }

    const isEmailValid = validate(formData.email);
    if (isEmailValid === false) {
      setError(prevState => ({ ...prevState, email: "Email should be valid" }))

      hasError = true
      return false
    }


    if (!hasError) {
      const data = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        role: 1
      };
      register(data);
    };
  }

  async function register(data: any) {
    const response = await addingRegisterDetails(data);
    const responseData = response.data;
    let theme = "success"
    if(response.status == 200) {
      setTimeout(() => navigate("/login"), 2000)
    } else {
      theme = "danger"
    }
    window.scrollTo(0,0);
    setShow(true);
    setMessage(responseData.message);
    setSuccessValue(theme);
  }

  const validate = (email: string) => {
    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      return true
    }
    return false
  }

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setError({ ...error, [name]: '' })
    setFormData({ ...formData, [name]: value })
  }

  const handlePhoneChange = (value: any) => {
    setError({ ...error, phone: '' });
    setFormData({ ...formData, phone: value });
  };

  const handleToggle = () => {
    setFormData({ ...formData, showPassword: !formData.showPassword });
}
const handleToggleEye = () => {
  setFormData({ ...formData, showConfirmPassword: !formData.showConfirmPassword });
}

  return (
    <Layout>

    <div className="signuppage_wrapper">
      <div className="container">
        <div className="col-sm-12 signuppage_section">
          <div className="col-sm-5 signuppage_right_part">
            <h2>Sign Up!</h2>
            <form onSubmit={handleSubmit}>
              <div className="col-sm-12 form-group">
                <span>Name</span>
                <span style={{ color: "red" }}>*</span>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {
                  error.name ?
                    <div >
                      <p style={{ color: "red" }}>{error.name}</p>
                    </div> : ""
                }
              </div>
              <div className="col-sm-12 form-group email">
                <span>E-mail adress</span>
                <span style={{ color: "red" }}>*</span>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="E-mail address"
                  value={formData.email}
                  onChange={handleChange} />
                {
                  error.email ?
                    <div >
                      <p style={{ color: "red" }}>{error.email}</p>
                    </div> : ""
                }
              </div>

              <div className="col-sm-12 form-group register_phone">
                <span>Phone Number</span>
                <span style={{ color: "red" }}>*</span>
                <PhoneInput
                  defaultCountry="IN"
                  // style={{
                  //     width: "100%",
                  //     maxWidth: "400px",
                  //     padding: "10px",
                  //     border: "2px solid #007bff",
                  //     borderRadius: "8px",
                  //     fontSize: "16px",
                  //     outline: "none",
                  //     transition: "0.3s",
                  //     boxSizing: "border-box",
                  // }}
                  // type='text'
                  international
                  value={formData.phone}
                  // value={email}
                  // onChange={event => setEmail(event.target.value)}
                  onChange={handlePhoneChange}
                  name="phone"
                  maxLength={16}
                />
                {
                  error.phone ?
                    <div >
                      <p style={{ color: "red" }}>{error.phone}</p>

                    </div> : ""
                }
              </div>

              <div className="col-sm-12 form-group">
                <span>Password</span>
                <span style={{ color: "red" }}>*</span>
                <div className='password-eye'>
                  <input type={formData.showPassword ? 'text' : 'password'} className="form-control" name="password" placeholder="Password" value={formData.password} onChange={handleChange} />
                  {formData.showPassword === false ?
                    <i onClick={handleToggle} className='bi bi-eye' />
                    :
                    <i onClick={handleToggle} className='bi bi-eye-slash' />
                  }
                </div>
                {
                  error.password ?
                    <div >
                      <p style={{ color: "red" }}>{error.password}</p>

                    </div> : ""
                }
              </div>

              <div className="col-sm-12 form-group">
                <span>Confirm Password</span>
                <span style={{ color: "red" }}>*</span>
                <div className='password-eye'>
                <input
                  type={formData.showConfirmPassword ? 'text' : 'password'}
                  className='form-control'
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  name="confirmPassword"
                />
                 {formData.showConfirmPassword === false ?
                    <i onClick={handleToggleEye} className='bi bi-eye' />
                    :
                    <i onClick={handleToggleEye} className='bi bi-eye-slash' />
                  }
                </div>
                {
                  error.password ?
                    <div >
                      <p style={{ color: "red" }}>{error.password}</p>

                    </div> : ""
                }
              </div>

              <div className="col-sm-12 signup_btn">
                <button type="button" id="form_cancel" onClick={() => navigate(`/${currentUser}/login`)}>Cancel</button>
                <button
                  type="submit"
                  id="form_signup"
                >
                  Signup
                  {/* {loading &&
                    <span className="ms-2">
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </span>
                  } */}
                </button>
              </div>
              {/* {
                err ?
                  <div >
                    <p style={{ color: "red" }}>{err}</p>

                  </div> : ""
              } */}
              <strong>Already have account? <a onClick={() => navigate(`/login`)} className="clickable">Log in</a></strong>
            </form>
          </div>
        </div>
        {/* <div className="col-sm-12 termsprivacy_section">
          <p>By login you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy.</a></p>
        </div> */}
      </div>
      {show &&
        <Toast className={successValue === "success" ? "float-start end-0 position-absolute show bg-success z-3" : "float-start end-0 position-absolute show bg-danger z-3"} style={{ top: "0px" }}>
          <Toast.Header className={`show ${successValue === "success" ? "bg-success" : "bg-danger"}`}>
            <strong className="me-auto text-white">Success Message</strong>
          </Toast.Header>
          <div aria-live="polite" aria-atomic="true" className="d-flex justify-content-center align-items-center w-100 mb-10 text-white bg-transparent">
            <div className="fade toast show  bg-transparent" role="alert" aria-live="assertive" aria-atomic="true">
              <div className="fade toast show bg-transparent p-4 text-white">
                {message}
              </div>
            </div>
          </div>
        </Toast>
      }
    </div>
    </Layout>
  );
};

export default Register;